import type { ListingLocaleOverrides } from '../base';
import {
  buyersAttorneyContactCard,
  sellersAttorneyContactCard,
} from '../cards';

export const MAOverrides: ListingLocaleOverrides = {
  locale: 'MA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.platbook',
                  size: 50,
                },
                {
                  name: 'property.pages',
                  size: 50,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            platbook: {
              name: 'property.platbook',
              entity: 'property',
              type: 'text',
              label: 'Book',
              placeholderText: '',
            },
            pages: {
              name: 'property.pages',
              entity: 'property',
              type: 'text',
              label: 'Page',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText: 'Copy legal description from tax records',
            },
          },
        },
      },
    },
    sellerSideContacts: {
      cards: {
        sellerCard: {
          fields: {
            powerOfAttorneyFirstName: {
              label: 'Authorized Signer First Name',
            },
            powerOfAttorneyLastName: {
              label: 'Authorized Signer Last Name',
            },
          },
        },
        sellersAttorneyContactCard,
      },
    },
    buyerSideContacts: {
      cards: {
        buyerCard: {
          fields: {
            powerOfAttorneyFirstName: {
              label: 'Authorized Signer First Name',
            },
            powerOfAttorneyLastName: {
              label: 'Authorized Signer Last Name',
            },
          },
        },
        buyersAttorneyContactCard,
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: null,
        addAdditionalContactCard: {
          fields: {
            newContact: {
              options: (options) =>
                options.filter(
                  ({ value }) => value !== 'additionalContacts.attorney',
                ),
            },
          },
        },
      },
    },
  },
};
